import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';

import { catchError, of, Subscription, tap } from 'rxjs';

import { InviteRole } from '@shared/invite/enums';
import { UserLocationRole } from '@shared/user/enums';
import { GlobalErrorHandler } from '@tablesready/common-ui';
import { ButtonColorsEnum } from '@tablesready/button-group-control';
import { UserWithLocation } from '../../models';
import { LocationApiService } from '../../../../../services';
import { FrontendModalService } from '@tablesready/frontend-modal';
import { AppIcon, AppIconColor } from '@tablesready/frontend-icons';
import { AlertsService } from '@tablesready/frontend-alerts-bar';

@Component({
  selector: 'tablesready-location-edit-user',
  templateUrl: './edit-user.component.html',
  providers: [GlobalErrorHandler],
})
export class EditUserComponent implements OnInit, OnDestroy {
  @Input() user: UserWithLocation;

  form: FormGroup;
  icon = AppIcon;
  color = AppIconColor;
  inProgress = false;
  buttonsColor = ButtonColorsEnum;
  roles = [
    {
      name: 'USER',
      value: InviteRole.user,
    },
    {
      name: 'MANAGER',
      value: InviteRole.manager,
    },
  ];

  private readonly subscriptions = new Subscription();

  constructor(
    private readonly fb: FormBuilder,
    private readonly modalController: FrontendModalService,
    private readonly alertsService: AlertsService,
    private readonly locationApiService: LocationApiService,
    private readonly globalErrorHandler: GlobalErrorHandler,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      role: [InviteRole[this.user.role], [Validators.required]],
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  updateUser(): void {
    let role;
    const value = this.form.value;

    switch (value.role) {
      case InviteRole.manager:
        role = UserLocationRole.manager;
        break;
      case InviteRole.user:
        role = UserLocationRole.user;
        break;
      default:
        role = UserLocationRole.user;
        break;
    }

    this.subscriptions.add(
      this.locationApiService.updateLocationUser(this.user.id, role)
        .pipe(
          tap(() => {
            this.alertsService.addSuccess('User successfully updated');
            this.close();
          }),
          catchError(err => {
            this.globalErrorHandler.handleError(err);

            return of(null);
          })
        ).subscribe(),
    );
  }

  get roleControl(): AbstractControl {
    return this.form.get('role');
  }

  close(): void {
    this.modalController.dismiss();
  }
}
